module.exports = __webpack_public_path__ + "img/message.711684c1.svg";